module.exports = __webpack_public_path__ + "img/lottery-default-cover.4dda877c.png";